var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPixis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3.49596,
    fill: "#F5F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0687 13.8981L13.5798 12.5151C13.6902 12.2164 13.8848 11.9595 14.1381 11.7783C14.3914 11.5971 14.6914 11.5001 14.9987 11.5H19.2649C19.3848 11.5006 19.5028 11.5315 19.6086 11.5902C19.7144 11.6489 19.8049 11.7335 19.8723 11.8367C19.9397 11.94 19.9819 12.0588 19.9954 12.1828C20.0088 12.3069 19.993 12.4325 19.9494 12.5488L19.4382 13.8981H13.0687ZM12.9113 14.3246L12.0286 16.715H17.169C17.5413 16.6817 17.8973 16.541 18.1971 16.3087C18.4969 16.0765 18.7286 15.7618 18.8662 15.4L19.2746 14.3246H12.9113ZM11.8713 17.1409L11 19.5H12.871C13.0873 19.5 13.2986 19.4318 13.4771 19.3043C13.6555 19.1769 13.7927 18.9962 13.8707 18.786L14.4813 17.1409H11.8713Z",
    fill: "url(#paint0_linear_614_78711)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_614_78711",
    x1: 15.5008,
    y1: 11.1924,
    x2: 15.5008,
    y2: 19.8041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F64FA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixis);
export default __webpack_public_path__ + "static/media/pixis.5565b99b75542d72b9d2d210d08d4c4e.svg";
export { ForwardRef as ReactComponent };